"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.toValidationError = exports.ValidationError = void 0;
const E = __importStar(require("fp-ts/Either"));
const PathReporter_1 = require("io-ts/PathReporter");
class ValidationError extends Error {
    errors;
    input;
    correlationId;
    report;
    constructor(message, errors, input, correlationId) {
        super(message);
        this.errors = errors;
        this.input = input;
        this.correlationId = correlationId;
        this.name = 'ValidationError';
        this.report = PathReporter_1.PathReporter.report(E.left(errors));
    }
}
exports.ValidationError = ValidationError;
const toValidationError = (message, input, correlationId) => (errors) => new ValidationError(message, errors, input, correlationId);
exports.toValidationError = toValidationError;
